import React from "react";
import { Form } from "react-bootstrap";
import { onNumberChange } from "helpers";
import { UpdateElectricityAgreementRenewalPlanModalForm } from "../modals/UpdateElectricityAgreementRenewalPlanModal";

interface UpdateElectricityAgreementRenewalPlanConsumptionPriceFormProps {
    form: UpdateElectricityAgreementRenewalPlanModalForm;
    setForm: (form: UpdateElectricityAgreementRenewalPlanModalForm) => void;
}

export default function UpdateElectricityAgreementRenewalPlanConsumptionPriceForm(
    { form, setForm } : UpdateElectricityAgreementRenewalPlanConsumptionPriceFormProps
) {    

    const getMonthlyFeeForm = () => {
        return (
            <div className="col-12 col-md-6 mt-3 mt-md-0">
                <Form.Label>Kuutasu KM-ta (€)*</Form.Label>
                <Form.Control
                    type="number"
                    value={form?.monthlyFeeEuros ?? ''}
                    step={0.001}
                    required    
                    onChange={(e: any) => setForm({
                        ...form,
                        monthlyFeeEuros: onNumberChange(e)
                    })}
                    onWheel={(e: any) => e.target.blur()}
                />
                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
            </div>           
        )
    }

    return (
        <>
            {
                form.twoTariffPackage && (
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <Form.Label>Päeva tariif (s/kWh)*</Form.Label>
                            <Form.Control
                                value={form?.dayTariffCentsKwh ?? ''}
                                step={0.001}
                                onChange={(e : any) => setForm({
                                        ...form,
                                        dayTariffCentsKwh: onNumberChange(e)
                                    })
                                }
                                required
                                type="number"
                                onWheel={(e: any) => e.target.blur()}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                        </div>
                        <div className="col-12 col-md-6 mt-3 mt-md-0">
                            <Form.Label>Öö tariif (s/kWh)*</Form.Label>
                            <Form.Control
                                value={form?.nightTariffCentsKwh ?? ''}
                                step={0.001}
                                onChange={(e : any) => setForm({
                                        ...form,
                                        nightTariffCentsKwh: onNumberChange(e)
                                    })
                                }
                                required
                                type="number"
                                onWheel={(e: any) => e.target.blur()}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                        </div>
                    </div>
                )
            }
            {
                form.fixedPackage && (
                    <div className={`row ${form.twoTariffPackage ? "mt-3" : ""}`}>
                        <div className="col-12 col-md-6">
                            <Form.Label>Baashind KM-ta (s/kWh)*</Form.Label>
                            <Form.Control
                                type="number"
                                value={form?.basePriceCentsKwh ?? ''}
                                step={0.001}
                                onChange={(e: any) => setForm({
                                    ...form,
                                    basePriceCentsKwh: onNumberChange(e)
                                })}
                                required={!form.twoTariffPackage}
                                onWheel={(e: any) => e.target.blur()}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                        </div>
                        { getMonthlyFeeForm() }                
                    </div>
                )        
            }
            <div className={`row ${form.marketPricePackage ? '' : 'mt-3'}`}>
                <div className="col-12 col-md-6">
                    <Form.Label>{'Marginaal KM-ta'} (s/kWh)*</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={form.consumptionMarginal ?? ''}
                        step={0.001}
                        onChange={(e: any) => setForm({
                            ...form,
                            consumptionMarginal: onNumberChange(e)
                        })}
                        onWheel={(e: any) => e.target.blur()}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                {
                     (form.twoTariffPackage || form.marketPricePackage) && (
                        <>
                            { getMonthlyFeeForm() }      
                        </>
                    )
                }
            </div>
        </>
    );
}